import { Col, Row, Table, Tag } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { useSelector } from 'react-redux';
import { currencyFormat } from '../../Utils/formatCurrency';
import { useLocation } from 'react-router-dom';
import { getStatusApproval } from '../../Utils/approval';

function SubmissionRegularDetail() {
  const token = useSelector((state) => state.user.token);
  const location = useLocation();
  const [product, setProduct] = useState([]);
  const [data, setData] = useState(null);
  const [benefit, setBenefit] = useState(null);
  const [approval, setApproval] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState({ pagination: { current: 1, pageSize: 10 } });

  const titlePage = 'Business Travel Submission Details';

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      render: (_, __, index) => (page.pagination.current - 1) * page.pagination.pageSize + index + 1
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.users.name
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      render: (_, record) => record.users.position.name
    },
    {
      title: 'Division',
      dataIndex: 'division',
      key: 'division',
      render: (_, record) => record.users.division.name
    },
    {
      title: 'Description',
      dataIndex: 'desc',
      key: 'desc'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => {
        const statusColor = record.status_approval.status_approval_id === 1
          ? 'blue'
          : record.status_approval.status_approval_id === 2
          ? 'green'
          : 'red';
        return <Tag color={statusColor}>{record.status_approval.status}</Tag>;
      }
    }
  ];

  const productColumns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      render: (_, __, index) => (page.pagination.current - 1) * page.pagination.pageSize + index + 1
    },
    { title: 'Product Name', dataIndex: 'product_name', key: 'product_name' },
    { title: 'Description', dataIndex: 'desc', key: 'desc' },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      render: (_, record) => currencyFormat(record.price)
    },
    { title: 'Qty', dataIndex: 'qty', key: 'qty' },
    {
      title: 'Total Price',
      dataIndex: 'total',
      key: 'total',
      render: (_, record) => currencyFormat(record.total)
    }
  ];

  useEffect(() => {
    if (location.state != null) {
      getApi('GET', '/requestbudgetproduct/' + location.state.item.budget_submission_id, 'request');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(page)]);

  const getApi = (method, url, type) => {
    setLoading(true);
    const dataReq = {
      method,
      url,
      data: {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
    };
    apiCall(dataReq).then((res) => {
      if (res.status === 'success') {
        switch (type) {
          case 'request':
            getApi('GET', '/benefitlevel?leveldetail=' + res.data.user.level_detail_id, 'benefit');
            setData(res.data);
            setApproval(res.data.approval);
            setProduct(res.data.budget_buy_product);
            break;
          case 'benefit':
            setBenefit(res.data.data[0]);
            break;
          default:
            break;
        }
      }
      setLoading(false);
    }).catch((e) => {
      console.log(e.message);
      setLoading(false);
    });
  };

  const checkStatus = () => (
    <Tag color={getStatusApproval(data).color}>{getStatusApproval(data).value}</Tag>
  );

  if (data && benefit) {
    return (
      <div>
        <Helmet>
          <title>{titlePage}</title>
        </Helmet>
        <h1>{data.budget_submission_code}</h1>
        <h3>Title: {data.title}</h3>
        {checkStatus()}
        <Row>
          <Col span={12}>
            <h4>Details</h4>
            <Row>
              <Col>
                <div>Description</div>
                <div>Estimated Budget</div>
                <div>Realization</div>
              </Col>
              <Col>
                <div>: {data.desc}</div>
                <div>: {currencyFormat(data.grand_total)}</div>
                <div>: {data.realisasi > 0 ? currencyFormat(data.realisasi) : 'Not yet realized'}</div>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <h4>Submitted By</h4>
            <Row>
              <Col>
                <div>Name</div>
                <div>Position</div>
                <div>Division</div>
              </Col>
              <Col>
                <div>: {data.user.name}</div>
                <div>: {data.user.position.name}</div>
                <div>: {data.user.division.name}</div>
              </Col>
            </Row>
          </Col>
        </Row>
        <br />
        <h4>Approved By</h4>
        <Table
          size="middle"
          columns={columns}
          dataSource={approval}
          pagination={page.pagination}
          loading={loading}
          onChange={(pagination) => setPage({ pagination })}
        />
        <h4>Product List</h4>
        <Table
          size="middle"
          columns={productColumns}
          dataSource={product}
          loading={loading}
        />
      </div>
    );
  }
}

export default SubmissionRegularDetail;
